import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import PerfisEmAscensao from "./sections/PerfisEmAscensao";
import StepByStepMigrationProcess from "./sections/StepByStepMigrationProcess";
import OurTrustedPartners from "./sections/OurTrustedPartners";
import FooterInfo from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <PerfisEmAscensao />
      <StepByStepMigrationProcess />
      <OurTrustedPartners />
      <FooterInfo />
    </div>;
}